<div class="login_wrapper">
  <div class="login_elements">
    <div class="login_logo">Excelsior</div>
  </div>
</div>
